import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { useState } from "react";
import InputText from "../../shared/input/new/InputText";
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect";
import InputPhoneNew from "../../shared/input/new/InputPhoneNew";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import { addAdminTruckSingle } from "../../../features/admin2/admin2Slice";
import InputSelect from "../../shared/input/new/InputSelect";
import MarkaOptions from "../../../utils/trAracMarkaOptions";
import InputDate from "../../shared/input/new/InputDate";
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions";
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect";
import moment from "moment";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: 550px;
    height: 550px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding: 20px 0px 0px 0px;
    overflow: auto;
    position: relative;
    .content {
      padding: 20px;
      .col {
        display: flex;
        flex-direction: column;
        .row {
          margin-block: 10px;
        }
      }
    }
    .btn {
      position: sticky;
      padding: 15px;
      display: flex;
      width: 100%;
      background-color: white;
      z-index: 5;
      align-items: center;
      justify-content: center;
      bottom: 0;
      
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const AdminAraclarTekliAracEkle = () => {
 
  const zeminTipiData = [
    {
      id:1,
      text:"Ahşap Taban"
    },
    {
      id:2,
      text:"Sac Taban"
    }
  ]

  const { modalLocation } = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  const [zeminType, setZeminType] = useState(null)
  const [initialCaseType, setInitialCaseType] = useState(null)
  const [selectCaseType, setSelectCaseType] = useState(null)
  const [phoneValue, setPhoneValue] = useState("");
  const [selectAracTur, setSelectAracTur] = useState(null);
  const [aracEkleValues, setAracEkleValues] = useState({
    plateNumber: "",
    phoneNumber:"",
    truckBrand: "",
    truckModel: "",
    truckModelYear: "",
    trafikSigortasıGecerlilikTarihi:"",
    muayeneGecerlilikTarihi:"",
    kaskoGecerlilikTarihi:""
  });
  const [selectAracMarka, setSelectAracMarka] = useState(null)

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleChange = (e) => {
    setAracEkleValues((prev) => ({
      ...prev,
      [e?.target?.name]: e?.target?.value,
    }));
  };

  const aracEkle = () => {
    const addData = {
      //! zorunlu alanlar
      phoneNumber: phoneValue,
      truckType: selectAracTur?.name,
      truckPlateNumber: aracEkleValues?.plateNumber,
      
      //! opsiyonel alanlar
      //! kasa ve zemin
      // trailerType: selectCaseType?.name || "",
      trailerTypeId: selectCaseType?.id,
      // groundType: zeminType?.text || "",

      //! araç detay
      truckBrand: selectAracMarka?.text || "",
      truckModel: aracEkleValues?.truckModel || "",
      truckModelYear: parseInt(aracEkleValues?.truckModelYear) || 0,

      //! tarihler
      trafikSigortasıGecerlilikTarihi: moment(aracEkleValues?.trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? null : moment(aracEkleValues?.trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
      muayeneGecerlilikTarihi: moment(aracEkleValues?.muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? null : moment(aracEkleValues?.muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
      kaskoGecerlilikTarihi: moment(aracEkleValues?.kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? null : moment(aracEkleValues?.kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY")
    };
    dispatch(addAdminTruckSingle(addData));
  };

  //! araç türü çekici ise kasa tipini sıfırla
  useEffect(() => {
    if(selectAracTur?.name === "Çekici"){
      setSelectCaseType(null)
    }
  },[selectAracTur])



  return (
    <Container onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal(null))}}>
      <div onClick={(e) => e.stopPropagation()}  className="modal">
        <PageTopTitle title={"Araç Ekle"} />
        <div className="content">
          <div className="col">
          
            <div className="row">
              <InputPhoneNew labelText="Telefon Numarası*" data={phoneValue} setData={setPhoneValue} name={"phoneValue"} />
            </div>

            <div className="row">
              <InputText
                data={aracEkleValues.plateNumber}
                setData={(e) => handleChange(e)}
                inputWidth={"100%"}
                labelText="Plaka*"
                name={"plateNumber"}
              />
            </div>
            
            <div className="row">
              <InputNewAracTypeSelect
                initialOptions={AdminAracEkleOptions}
                setInitialCaseType={setInitialCaseType}
                data={selectAracTur}
                setData={setSelectAracTur}
                inputWidth={"100%"}
                labelText="Araç Türü*"
                name={"selectAracTur"}
              />
            </div>

            {
              selectAracTur?.name !== "Çekici" &&
              <div className="row">
                <InputCaseTypeSelect 
                  initialOptions={initialCaseType}
                  data={selectCaseType}
                  setData={setSelectCaseType}
                  inputWidth={"100%"}
                  labelText="Kasa Tipi (Opsiyonel)"
                  name={"selectCaseType"}
                />
              </div>
            }

            {/* <div className="row">
              <InputSelect
                initialOptions={zeminTipiData}
                data={zeminType?.text}
                setData={setZeminType}
                inputWidth={"100%"}
                labelText="Zemin Tipi (Opsiyonel)"
                name={"zeminType"}
              />
            </div> */}
            
            <div className="row">
                <InputSelect
                  initialOptions={MarkaOptions}
                  data={selectAracMarka?.text || selectAracMarka}
                  setData={setSelectAracMarka}
                  inputWidth={"100%"}
                  labelText="Araç Markası (Opsiyonel)"
                  name={"truckBrand"}
                />
              </div>

              <div className="row">
                <InputText
                  data={aracEkleValues.truckModel}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Araç Modeli (Opsiyonel)"
                  name={"truckModel"}
                />
              </div>

              <div className="row">
                <InputText
                  data={aracEkleValues.truckModelYear}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Araç Model Yılı (Opsiyonel)"
                  name={"truckModelYear"}
                />
              </div>

              {
                (selectAracTur?.name !== "Y.Römork" && selectAracTur?.name !== "Römork") &&
                <div className="row">
                  <InputDate
                    data={aracEkleValues.trafikSigortasıGecerlilikTarihi}
                    setData={(e) => handleChange(e)}
                    inputWidth={"100%"}
                    labelText="Trafik Sigortası Geçerlilik Tarihi (Opsiyonel)"
                    name={"trafikSigortasıGecerlilikTarihi"}
                  />
                </div>
              }
              
              <div className="row">
                <InputDate
                  data={aracEkleValues.muayeneGecerlilikTarihi}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Muayene Geçerlilik Tarihi (Opsiyonel)"
                  name={"muayeneGecerlilikTarihi"}
                />
              </div>
              <div className="row">
                <InputDate
                  data={aracEkleValues.kaskoGecerlilikTarihi}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Kasko Geçerlilik Tarihi (Opsiyonel)"
                  name={"kaskoGecerlilikTarihi"}
                />
              </div>

          </div>
        </div>
        <div className="btn">
          <Button
            width="150px"
            handleClick={aracEkle}
            padding="10px"
            bgColor="#fff"
            color={"#E85446"}
          >
            Ekle
          </Button>
          <Button
            width="150px"
            handleClick={() => dispatch(showModal(null))}
            padding="10px"
            bgColor="#E85446"
            color={"#fff"}
          >
            Vazgeç
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AdminAraclarTekliAracEkle;
